<ul class="filters-workflow-subsection">
    <li *ngFor="let workflow of workflows | sortBy: 'id' : 'asc' " (click)="onOpen(workflow)" [ngClass]="{opened: opened == workflow.id}">
        <span class="filter-subtitle"><em>{{workflow.name}}</em></span>
        <div class="workflows-listed">
        <app-helpers-search-filters-workflow-status-status
            [hidden]="opened != workflow.id"
            [available]="getStatus(workflow)"
            [selecteds]="selecteds"
            (choose)="onSelect($event)"
        ></app-helpers-search-filters-workflow-status-status>
        </div>
    </li>
</ul>
